import React, {memo} from "react";
import styles from "./styles.module.scss";
import {TextBold16, TextMedium16} from "@/app/components/texts";
import classNames from "classnames";
import CustomCssTransition from "@/app/components/custom_css_transition/widget";
import {useMediaQuery} from "@/app/utils/custom_function";

interface Props {
  value: boolean,
  onChange: (value: boolean) => void
  title: string
  titleDesktop: string
  subtitleDesktop: string
}

const SwitchWidget: React.FC<Props> = ({value, onChange, title, titleDesktop, subtitleDesktop}) => {
  const isDesktop = useMediaQuery('(min-width:1024px)');

  return (<div className={classNames(styles.switchWrapper, {[styles.active]: value})} onClick={() => onChange(!value)}>
    <CustomCssTransition bool={value}>
      {
        isDesktop ?

          value ?
            <div className={styles.titleAndSubtitle}>
              <TextBold16 text={titleDesktop} className={styles.title}/>
              <TextMedium16 text={subtitleDesktop} className={styles.subtitle}/>
            </div>
            :
            <div className={styles.titleAndSubtitle}>
              <TextBold16 text={titleDesktop} className={styles.title}/>
              <TextMedium16 text={subtitleDesktop} className={styles.subtitle}/>
            </div>
          : value ? <TextMedium16 text={title} className={styles.title}/> :
            <TextMedium16 text={title} className={styles.title}/>
      }
    </CustomCssTransition>
    <div className={classNames(styles.switch, {[styles.active]: value})}>
      <div className={classNames(styles.slider, {[styles.active]: value})}></div>
    </div>
  </div>);
};

export default memo(SwitchWidget);